const LEFT_STATUS = 'Left in between';

/**
 * True if any enrollment is marked as left mid-course.
 * @param {{ enrollments?: Array<{ batchStatus?: string }> }} student
 */
export function hasLeftEnrollment(student) {
  const enrollments = student?.enrollments;
  if (!Array.isArray(enrollments) || enrollments.length === 0) return false;
  return enrollments.some((en) => en?.batchStatus === LEFT_STATUS);
}

/**
 * Enrollment used for status updates: ongoing first, else most recent (API order).
 * @param {{ enrollments?: Array<{ batchStatus?: string, enrollmentDate?: string }> }} student
 */
export function getPrimaryEnrollment(student) {
  const enrollments = student?.enrollments;
  if (!Array.isArray(enrollments) || enrollments.length === 0) return null;
  const ongoing = enrollments.find((en) => en?.batchStatus === 'Ongoing');
  return ongoing || enrollments[0];
}

export { LEFT_STATUS };
